/**
 * Translation catalogue — Glories of India Publications
 *
 * Source-of-truth for user-facing UI strings. Ships English strings live;
 * Hindi (hi) and Bengali (bn) fields are left empty deliberately — the
 * publisher (Ira) enters approved translations via Admin → Translations,
 * or by extending this file directly. Empty hi/bn values fall back to English
 * WITH an "EN" pill next to the specific string so visitors know it hasn't
 * been translated yet.
 *
 * Scope: navigation, main CTAs, form labels, form validation, consent
 * notices, confirmation messages, footer generics, book-detail block
 * headings, reservation form, contact form. Book content (title/description)
 * is separately translated per-book via the editions_meta / translations
 * fields on each book record.
 *
 * If you add a new visible string in the codebase, add a matching key here
 * so it appears in the translation admin page.
 */
export const CATALOGUE = {
  // ---- Navigation ----
  "nav.home":                 { en: "Home", hi: "", bn: "" },
  "nav.books":                { en: "Books", hi: "", bn: "" },
  "nav.about":                { en: "About the Author", hi: "", bn: "" },
  "nav.research_themes":      { en: "Research Themes", hi: "", bn: "" },
  "nav.articles":             { en: "Articles", hi: "", bn: "" },
  "nav.events":               { en: "Events", hi: "", bn: "" },
  "nav.media":                { en: "Media", hi: "", bn: "" },
  "nav.join":                 { en: "Join the Mission", hi: "", bn: "" },
  "nav.contact":              { en: "Contact", hi: "", bn: "" },
  "nav.search":               { en: "Search", hi: "", bn: "" },
  "nav.more":                 { en: "More", hi: "", bn: "" },

  // ---- Common actions ----
  "common.read_more":         { en: "Read more", hi: "", bn: "" },
  "common.view_all":          { en: "View all", hi: "", bn: "" },
  "common.submit":            { en: "Submit", hi: "", bn: "" },
  "common.save":              { en: "Save", hi: "", bn: "" },
  "common.cancel":            { en: "Cancel", hi: "", bn: "" },
  "common.close":             { en: "Close", hi: "", bn: "" },
  "common.copy":              { en: "Copy", hi: "", bn: "" },
  "common.loading":           { en: "Loading…", hi: "", bn: "" },
  "common.saving":            { en: "Saving…", hi: "", bn: "" },
  "common.subscribe":         { en: "Subscribe", hi: "", bn: "" },
  "common.subscribing":       { en: "Subscribing…", hi: "", bn: "" },
  "common.learn_more":        { en: "Learn more", hi: "", bn: "" },
  "common.back":              { en: "Back", hi: "", bn: "" },

  // ---- Home ----
  "home.hero.eyebrow_default": { en: "Glories of India Series", hi: "", bn: "" },
  "home.cta.explore_books":   { en: "Explore the Books", hi: "", bn: "" },
  "home.cta.join_mission":    { en: "Join the Mission", hi: "", bn: "" },
  "home.cta.watch":           { en: "Watch Introduction", hi: "", bn: "" },
  "home.cta.about_author":    { en: "About the Author", hi: "", bn: "" },
  "home.section.featured":    { en: "Featured Books", hi: "", bn: "" },
  "home.section.green_guru":  { en: "Green Guru Knowledge Series", hi: "", bn: "" },
  "home.section.why":         { en: "Why These Books Exist", hi: "", bn: "" },
  "home.section.research":    { en: "Research Approach", hi: "", bn: "" },
  "home.section.author":      { en: "Author's Journey", hi: "", bn: "" },
  "home.section.watch":       { en: "Watch & Explore", hi: "", bn: "" },
  "home.section.join":        { en: "Join the Mission", hi: "", bn: "" },
  "home.section.articles":    { en: "Latest Articles", hi: "", bn: "" },
  "home.section.events":      { en: "Events", hi: "", bn: "" },
  "home.section.newsletter":  { en: "Newsletter", hi: "", bn: "" },
  "home.viewall.books":       { en: "View All Titles", hi: "", bn: "" },
  "home.viewall.green_guru":  { en: "Explore the Green Guru Series", hi: "", bn: "" },
  "home.author.read_story":   { en: "Read the Author's Story", hi: "", bn: "" },

  // ---- Book detail blocks ----
  "book.overview":            { en: "Overview", hi: "", bn: "" },
  "book.details":             { en: "Details", hi: "", bn: "" },
  "book.toc":                 { en: "Table of Contents", hi: "", bn: "" },
  "book.why_read":            { en: "Why Read This Book", hi: "", bn: "" },
  "book.what_learn":          { en: "What Readers Will Learn", hi: "", bn: "" },
  "book.practical_topics":    { en: "Practical Topics Covered", hi: "", bn: "" },
  "book.research_themes":     { en: "Research Themes", hi: "", bn: "" },
  "book.quotations":          { en: "Selected Quotations", hi: "", bn: "" },
  "book.reviews":             { en: "Reviews", hi: "", bn: "" },
  "book.trailer":             { en: "Book Trailer", hi: "", bn: "" },
  "book.related":             { en: "Related Titles", hi: "", bn: "" },
  "book.buy_amazon":          { en: "Buy on Amazon", hi: "", bn: "" },
  "book.buy_green_mall":      { en: "Buy on Green Mall", hi: "", bn: "" },
  "book.buy_goodreads":       { en: "View on Goodreads", hi: "", bn: "" },
  "book.read_sample":         { en: "Read Sample", hi: "", bn: "" },
  "book.download_sample":     { en: "Download Sample", hi: "", bn: "" },

  // ---- Reservation form ----
  "res.button":               { en: "Reserve Print Copy", hi: "", bn: "" },
  "res.header":               { en: "Reserve print copy", hi: "", bn: "" },
  "res.name":                 { en: "Full name", hi: "", bn: "" },
  "res.email":                { en: "Email", hi: "", bn: "" },
  "res.phone":                { en: "Phone / WhatsApp", hi: "", bn: "" },
  "res.city":                 { en: "City", hi: "", bn: "" },
  "res.state":                { en: "State / province", hi: "", bn: "" },
  "res.country":              { en: "Country", hi: "", bn: "" },
  "res.edition":              { en: "Preferred edition / language", hi: "", bn: "" },
  "res.quantity":             { en: "Number of copies", hi: "", bn: "" },
  "res.notes":                { en: "Optional note", hi: "", bn: "" },
  "res.consent":              { en: "I consent to the publisher storing this information solely to process my reservation and contact me about this title.", hi: "", bn: "" },
  "res.notice":               { en: "This is a non-binding reservation, not a completed purchase. Price, availability, shipping charges and delivery schedule will be confirmed before payment.", hi: "", bn: "" },
  "res.confirmation.title":   { en: "Reservation received", hi: "", bn: "" },
  "res.confirmation.thanks":  { en: "Thank you. Your reservation has been recorded. Please keep this reference number for your records; the publisher will contact you before payment.", hi: "", bn: "" },
  "res.reference_number":     { en: "Reference number", hi: "", bn: "" },
  "res.submit":               { en: "Submit reservation", hi: "", bn: "" },

  // ---- Contact form ----
  "contact.name":             { en: "Name", hi: "", bn: "" },
  "contact.email":            { en: "Email", hi: "", bn: "" },
  "contact.phone":            { en: "Phone (optional)", hi: "", bn: "" },
  "contact.category":         { en: "Category", hi: "", bn: "" },
  "contact.subject":          { en: "Subject", hi: "", bn: "" },
  "contact.message":          { en: "Message", hi: "", bn: "" },
  "contact.submit":           { en: "Send message", hi: "", bn: "" },
  "contact.success":          { en: "Thank you — your message has been received. The publisher will respond by email.", hi: "", bn: "" },

  // ---- Newsletter ----
  "news.name":                { en: "Name", hi: "", bn: "" },
  "news.email":               { en: "Email", hi: "", bn: "" },
  "news.country":             { en: "Country", hi: "", bn: "" },
  "news.language":            { en: "Preferred Language", hi: "", bn: "" },
  "news.interests":           { en: "Areas of Interest", hi: "", bn: "" },
  "news.consent":             { en: "I consent to receive occasional updates.", hi: "", bn: "" },
  "news.success":             { en: "Thank you. Please expect updates from the Glories of India desk.", hi: "", bn: "" },

  // ---- Validation / errors ----
  "err.required_all":         { en: "Please fill all required fields.", hi: "", bn: "" },
  "err.consent_required":     { en: "Please tick the consent box.", hi: "", bn: "" },
  "err.phone_invalid":        { en: "Please provide a valid phone number.", hi: "", bn: "" },
  "err.email_invalid":        { en: "Please provide a valid email address.", hi: "", bn: "" },
  "err.retry_later":          { en: "Submission could not be completed — please try again shortly.", hi: "", bn: "" },

  // ---- Footer ----
  "footer.copyright":         { en: "All rights reserved.", hi: "", bn: "" },
  "footer.tagline":           { en: "Rediscovering India · Evidence · Exploration · Inquiry", hi: "", bn: "" },
};

/** Total keys in the catalogue */
export const TOTAL_KEYS = Object.keys(CATALOGUE).length;

/** Convenience: how many translations exist for a given language */
export const translatedCount = (lang) => Object.values(CATALOGUE).filter(v => (v[lang] || "").trim()).length;
